package org.example.zone360.pages.widgets.competitiveWidget


import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.icons.fa.FaAngleRight
import com.varabyte.kobweb.silk.components.icons.fa.FaBullseye
import com.varabyte.kobweb.silk.components.icons.fa.FaClock
import com.varabyte.kobweb.silk.components.icons.fa.FaFlag
import com.varabyte.kobweb.silk.components.icons.fa.FaTrophy
import com.varabyte.kobweb.silk.components.icons.fa.FaUser
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.window
import org.example.zone360.components.widgetTitleFontSize
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.CompetitiveEnvironment
import org.example.zone360.models.WidgetDetailResponse
import org.example.zone360.models.WidgetTrend
import org.example.zone360.pages.dashboard.chart.MiniBars
import org.example.zone360.pages.widgets.helper.WidgetTooltipIcon
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.CheckboxInput
import org.w3c.dom.HTMLInputElement

@Composable
fun CompetitiveEnvironmentWidget(
    data: CompetitiveEnvironment,
    modifier: Modifier = Modifier,
    widgetNo: Int,
    widgetName: String,
    widgetColor: Color,
    isCoachPage: Boolean = false,
    showSelection: Boolean = false,
    sessionBorder: Boolean = false,
    forceFullWidth: Boolean = false,
    trendData: List<WidgetTrend> = emptyList(),
    isSelected: Boolean = false,
    onSelectionChange: ((Boolean) -> Unit)? = null,
    tooltipText: String = "",
    tooltipTitle: String = "",
    tooltipInline: Boolean = false
) {
    val scope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    var isModalOpen by remember { mutableStateOf(false) }
    var widgetDetailResponse by remember { mutableStateOf<WidgetDetailResponse?>(null) }
    var isLoading by remember { mutableStateOf(false) }

    Box(
        modifier = modifier
            .then(
                when {
                    forceFullWidth -> Modifier.fillMaxHeight()   // ✅ session detail
                    sessionBorder -> Modifier.fillMaxWidth()    // ✅ session border card
                    else -> Modifier.minWidth(                  // ✅ normal dashboard
                        when {
                            breakpoint < Breakpoint.MD -> 320.px
                            showSelection -> 280.px
                            window.screen.width in 1200..1500 -> 318.px
                            else -> 350.px
                        }
                    )
                }
            )
            .backgroundColor(sitePalette.modalBackgroundColor.rgb)
            .borderRadius(if (showSelection) 12.px else 16.px)
            .padding(if (showSelection) 12.px else if (sessionBorder) 15.px else 20.px)
            .border(
                if (showSelection) 2.px else if (sessionBorder) 1.px else 0.px,
                LineStyle.Solid,
                color = Palette.CardBorder.rgbLight
            )
            .then(
                when {
                    breakpoint < Breakpoint.MD -> Modifier
                    sessionBorder -> Modifier.height(285.px)
                    !showSelection -> Modifier.height(380.px)
                    else -> Modifier
                }
            )
            .styleModifier { property("position", "relative") }
    ) {
        // ── Checkbox ──────────────────────────────────────────────
        if (showSelection) {
            Box(
                modifier = Modifier
                    .styleModifier {
                        property("position", "absolute")
                        property("top", "9px")
                        property("right", "9px")
                        property("cursor", "pointer")
                    }
                    .zIndex(9999)
            ) {
                CheckboxInput(checked = isSelected) {
                    onChange { event ->
                        onSelectionChange?.invoke((event.target as HTMLInputElement).checked)
                    }
                    style {
                        property("transform", "scale(1.4)")
                        property("cursor", "pointer")
                    }
                }
            }
        }

        Column(modifier = Modifier.fillMaxWidth()
            .then(
                if (breakpoint < Breakpoint.MD) Modifier
                else Modifier.height(if (showSelection) 350.px else 340.px)
            )) {

            // ── Header ────────────────────────────────────────────
            Row(
                verticalAlignment = if (sessionBorder) Alignment.Top else Alignment.CenterVertically,
                modifier = Modifier.fillMaxWidth().margin(bottom = 8.px)
                    .then(
                        if (showSelection) Modifier.padding(right = 26.px) else Modifier
                    )
            ) {
                Box(
                    modifier = Modifier
                        .width(if (sessionBorder) 24.px else 28.px)
                        .height(if (sessionBorder) 24.px else 28.px)
                        .backgroundColor(widgetColor)
                        .borderRadius(6.px)
                        .margin(right = 10.px),
                    contentAlignment = Alignment.Center
                ) {
                    FieldTitleTextNormalSimple(
                        text = widgetNo.toString(),
                        fontSize = 14.px,
                        fontWeight = 700,
                        color = sitePalette.bodyBackground.rgb
                    )
                }
                FieldTitleTextNormalSimple(
                    text = widgetName,
                    fontSize = widgetTitleFontSize(showSelection, sessionBorder, breakpoint),
                    fontWeight = 700
                )
                if (tooltipInline && showSelection) {
                    if (tooltipText.isNotEmpty()) {
                        WidgetTooltipIcon(
                            tooltipText = tooltipText,
                            tooltipTitle = tooltipTitle,
                            modifier = Modifier.margin(left = 6.px, bottom = 13.px)
                        )
                    }
                } else {
                    if (!showSelection) {
                        Box(modifier = Modifier.weight(1f))
                    }
                    if (tooltipText.isNotEmpty()) {
                        WidgetTooltipIcon(
                            tooltipText = tooltipText,
                            tooltipTitle = tooltipTitle,
                            modifier = Modifier.margin(left = 8.px)
                        )
                    }
                }
            }

            // ── Sub-score rows ────────────────────────────────────
            Column(
                modifier = Modifier.fillMaxWidth().margin(top = 10.px)
                    .padding(right = 10.px)
                    .height(
                        when {
                            sessionBorder -> 162.px
                            showSelection -> 190.px
                            else -> 200.px
                        }
                    )
            ) {
                CompetitiveMetricRow(
                    label = "Competition",
                    showSelection = showSelection,
                    value = data.subScores.competition.toInt(),
                    icon = { FaTrophy(size = IconSize.SM, modifier = Modifier.color(Color.rgb(59, 109, 17))) },
                    iconBg = Color.rgb(234, 243, 222),
                    barColor = Color.rgb(99, 153, 34),
                    sessionBorder = sessionBorder
                )
                CompetitiveMetricRow(
                    label = "Accountability",
                    showSelection = showSelection,
                    value = data.subScores.accountability.toInt(),
                    icon = { FaUser(size = IconSize.SM, modifier = Modifier.color(Color.rgb(133, 79, 11))) },
                    iconBg = Color.rgb(250, 238, 218),
                    barColor = Color.rgb(239, 159, 39),
                    sessionBorder = sessionBorder
                )
                CompetitiveMetricRow(
                    label = "Scoring systems",
                    showSelection = showSelection,
                    value = data.subScores.scoringSystems.toInt(),
                    icon = { FaBullseye(size = IconSize.SM, modifier = Modifier.color(Color.rgb(59, 109, 17))) },
                    iconBg = Color.rgb(234, 243, 222),
                    barColor = Color.rgb(99, 153, 34),
                    sessionBorder = sessionBorder
                )
                CompetitiveMetricRow(
                    label = "Time pressure",
                    showSelection = showSelection,
                    value = data.subScores.timePressure.toInt(),
                    icon = { FaClock(size = IconSize.SM, modifier = Modifier.color(Color.rgb(59, 109, 17))) },
                    iconBg = Color.rgb(234, 243, 222),
                    barColor = Color.rgb(99, 153, 34),
                    sessionBorder = sessionBorder
                )
                CompetitiveMetricRow(
                    label = "Win criteria",
                    showSelection = showSelection,
                    value = data.subScores.winningConditions.toInt(),
                    icon = { FaFlag(size = IconSize.SM, modifier = Modifier.color(Color.rgb(133, 79, 11))) },
                    iconBg = Color.rgb(250, 238, 218),
                    barColor = Color.rgb(239, 159, 39),
                    sessionBorder = sessionBorder
                )
            }

            // ── Score + Club Avg pill ─────────────────────────────
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.fillMaxWidth().padding(leftRight = 5.px)
                    .margin(
                        bottom = if (sessionBorder) 0.px else if (isCoachPage) 4.px else 14.px,
                        top = if (sessionBorder) 0.px else if (isCoachPage) 12.px else 0.px
                    )
            ) {
                Row(
                    verticalAlignment = Alignment.Bottom,
                    modifier = Modifier.weight(1)
                ) {
                    FieldTitleTextNormalSimple(
                        text = data.score.toString(),
                        fontSize = 24.px,
                        fontWeight = 700
                    )
                    FieldTitleTextNormalSimple(
                        text = "/100",
                        fontSize = 13.px,
                        fontWeight = 400,
                        color = Palette.CoachTalkTableHeaderText.rgbLight,
                        marginLeft = 2.px
                    )
                }
                val avgLabel = when {
                    sessionBorder -> "Avg"
                    isCoachPage -> "Coach Avg"
                    else -> "Club Avg"
                }
                Spacer()
                Box(
                    modifier = Modifier
                        .backgroundColor(Palette.WidgetAverageBackground.rgbLight)
                        .borderRadius(99.px)
                        .padding(leftRight = 10.px, topBottom = 4.px),
                    contentAlignment = Alignment.Center
                ) {
                    FieldTitleTextNormalSimple(
                        text = "$avgLabel: ${data.score}",
                        fontSize = 11.px,
                        fontWeight = 500,
                        color =  Palette.WidgetAverageText.rgbLight
                    )
                }
            }

            // ── Sparkline (coach page) ────────────────────────────
            if (!sessionBorder) {
                if (isCoachPage) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .margin(top = if (showSelection) 4.px else 8.px),
                        contentAlignment = Alignment.Center
                    ) {
                        Box(
                            modifier = Modifier
                                .cursor(Cursor.Pointer)
                                .margin(top = 4.px)
                        ) {
                            MiniBars(
                                color = widgetColor,
                                trends = trendData
                            )
                        }
                    }
                }
                Spacer()
                // ── View Details button ───────────────────────────────
                if (!isCoachPage) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(42.px)
//                            .margin(top = if (window.screen.width > 1550) 5.px else 16.px)
                            .backgroundColor(Palette.ViewDetailBackground.rgbLight)
                            .borderRadius(10.px)
                            .border(
                                1.px,
                                LineStyle.Solid,
                                color = Palette.ViewDetailBorder.rgbLight
                            )
                            .cursor(Cursor.Pointer)
                            .onClick {
                                isModalOpen = true
                            }
                    ) {
                        Box(
                            modifier = Modifier.fillMaxSize(),
                            contentAlignment = Alignment.Center
                        ) {
                            FieldTitleTextNormalSimple(
                                text = "View Details",
                                fontSize = 14.px,
                                fontWeight = 600,
                                color = Palette.ViewDetailText.rgbLight
                            )

                        }
                        Box(
                            modifier = Modifier
                                .fillMaxHeight()
                                .fillMaxWidth()
                                .padding(right = 14.px),
                            contentAlignment = Alignment.CenterEnd
                        ) {
                            FaAngleRight(
                                modifier = Modifier
                                    .width(14.px)
                                    .height(14.px)
                                    .color(Palette.ViewDetailAngle.rgbLight)
                            )
                        }
                    }
                }
            }
        }
    }

    if (isModalOpen) {
        CompetitiveModal(
            widgetNo = widgetNo,
            widgetName = widgetName,
            widgetColor = widgetColor,
            response = null,
            widgetKey = "competitive_environment",
            clubAverage = data.score.toInt(),
            onClose = { isModalOpen = false }
        )
    }
}

@Composable
fun CompetitiveMetricRow(
    label: String,
    value: Int,
    iconBg: Color,
    barColor: Color,
    sessionBorder: Boolean = false,
    showSelection: Boolean = false,
    icon: @Composable () -> Unit,
) {
    var animatedValue by remember { mutableStateOf(0) }

    LaunchedEffect(value) {
        kotlinx.coroutines.delay(50)
        animatedValue = value
    }

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .margin(
                bottom = if (
                    showSelection ||
                    sessionBorder ||
                    window.screen.width in 1300..1520
                ) 5.px else 8.px
            ),
        verticalAlignment = Alignment.CenterVertically
    ) {
        // Icon box
        Box(
            modifier = Modifier
                .size(if (sessionBorder) 24.px else 28.px)
                .backgroundColor(iconBg)
                .borderRadius(8.px),
            contentAlignment = Alignment.Center
        ) {
            icon()
        }

        FieldTitleTextNormalSimple(
            text = label,
            width = if (window.screen.width > 1600) 115.px else 120.px,
            fontSize = 12.px,
            fontWeight = 400,
            marginLeft = 8.px,
            marginRight = 6.px,
            color = Palette.CoachTalkTableHeaderText.rgbLight
        )

        // Progress bar — animated fill
        Box(
            modifier = Modifier
                .weight(1f)
                .height(5.px)
                .backgroundColor(Color.rgb(229, 231, 235))
                .borderRadius(99.px)
        ) {
            Box(
                modifier = Modifier
                    .fillMaxHeight()
                    .fillMaxWidth(animatedValue.percent)
                    .backgroundColor(barColor)
                    .borderRadius(99.px)
                    .styleModifier {
                        property("transition", "width 0.8s ease-out")
                    }
            )
        }

        FieldTitleTextNormalSimple(
            text = animatedValue.toString(),
            fontSize = 12.px,
            fontWeight = 500,
            marginLeft = if (window.screen.width > 1600) 20.px else 8.px,
        )
    }
}
